import { render } from "./BookingTableMobile.vue?vue&type=template&id=5e51a72c&scoped=true"
import script from "./BookingTableMobile.vue?vue&type=script&lang=js"
export * from "./BookingTableMobile.vue?vue&type=script&lang=js"

import "./BookingTableMobile.vue?vue&type=style&index=0&id=5e51a72c&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e51a72c"]])

export default __exports__